$(document).ready(function () {
  // Troca de formulario

  $("#header-frame-vdp-popup .passagens-frame").click(function () {
    $("#passagem-frame-vdp-popup").addClass("active-form");

    $("#header-frame-vdp-popup .passagens-frame").addClass("active");
  });

  $("#header-frame-vdp-sidebar .passagens-frame").click(function () {
    $("#passagem-frame-vdp").addClass("active-form");

    $("#header-frame-vdp-sidebar .passagens-frame").addClass("active");
  });

  // Mask

  $(".masc-celular").mask("(00)000000000");

  //-----------------------------------------------------------------------------------------------------

  // Auto Suggest - Embarque

  const inputElementembarque_sidebar = $(
    "#passagem-frame-vdp .embarque-passagem"
  );
  const suggestionsElementembarque_sidebar = $(
    "#passagem-frame-vdp .suggestions-embarque"
  );
  const noResultsMessageembarque_sidebar = "Nenhum local encontrado.";

  const reverseSidebar = $(".sidebar-reverse-destino");

  inputElementembarque_sidebar.on("input", function () {
    const term = $(this).val();
    reverseSidebar.css("display", "none");
    suggestionsElementembarque_sidebar.css("display", "block");

    $.ajax({
      url: `https://geo.vaidepromo.com.br/autosuggest?term=${term}`,
      method: "GET",
      success: function (data) {
        suggestionsElementembarque_sidebar.empty();

        if (data.result.length === 0) {
          const noResultsItem_sidebar = `<li class="no-results">${noResultsMessageembarque_sidebar}</li>`;
          suggestionsElementembarque_sidebar.append(noResultsItem_sidebar);
        } else {
          data.result.forEach(function (item) {
            const airportCode_sidebar = item[0];
            const airportName_sidebar = item[1];
            const suggestionItem_sidebar = `<li data-value="${airportName_sidebar}">${airportName_sidebar}</li>`;
            suggestionsElementembarque_sidebar.append(suggestionItem_sidebar);
          });
        }
      },
      error: function (error) {
        console.error("Erro na solicitação AJAX: " + error);
      },
    });
  });

  suggestionsElementembarque_sidebar.on("click", "li", function () {
    const selectedValue = $(this).data("value");
    inputElementembarque_sidebar.val(selectedValue);
    reverseSidebar.css("display", "block");
    suggestionsElementembarque_sidebar.css("display", "none");
    $(".localvdp").css("border-radius", "16px");
  });

  inputElementembarque_sidebar.on("input", function () {
    if ($(this).val().trim() !== "") {
      suggestionsElementembarque_sidebar.empty();
    }
  });

  // Limpar input se não houver seleção de sugestão e suggestionsElementembarque_sidebar estiver aberto
  $(document).on("click", function (e) {
    if (
      suggestionsElementembarque_sidebar.css("display") === "block" &&
      !$(e.target).closest(suggestionsElementembarque_sidebar).length &&
      !$(e.target).is(inputElementembarque_sidebar) &&
      !$(e.target).hasClass("suggestions-embarque")
    ) {
      const selectedValue = suggestionsElementembarque_sidebar
        .find("li.active")
        .data("value");
      if (!selectedValue) {
        inputElementembarque_sidebar.val("");
        suggestionsElementembarque_sidebar.empty();
      }
    }
  });

  //

  const inputElementembarque_popup = $(
    "#passagem-frame-vdp-popup .embarque-passagem"
  );
  const suggestionsElementembarque_popup = $(
    "#passagem-frame-vdp-popup .suggestions-embarque"
  );
  const noResultsMessageembarque_popup = "Nenhum local encontrado.";

  const reversePopup = $(".popup-reverse-destino");

  inputElementembarque_popup.on("input", function () {
    const term = $(this).val();
    reversePopup.css("display", "none");
    suggestionsElementembarque_popup.css("display", "block");

    $.ajax({
      url: `https://geo.vaidepromo.com.br/autosuggest?term=${term}`,
      method: "GET",
      success: function (data) {
        suggestionsElementembarque_popup.empty();

        if (data.result.length === 0) {
          const noResultsItem_popup = `<li class="no-results">${noResultsMessageembarque_popup}</li>`;
          suggestionsElementembarque_popup.append(noResultsItem_popup);
        } else {
          data.result.forEach(function (item) {
            const airportCode_popup = item[0];
            const airportName_popup = item[1];
            const suggestionItem_popup = `<li data-value="${airportName_popup}">${airportName_popup}</li>`;
            suggestionsElementembarque_popup.append(suggestionItem_popup);
          });
        }
      },
      error: function (error) {
        console.error("Erro na solicitação AJAX: " + error);
      },
    });
  });

  suggestionsElementembarque_popup.on("click", "li", function () {
    const selectedValue = $(this).data("value");
    inputElementembarque_popup.val(selectedValue);
    suggestionsElementembarque_popup.empty();
    reversePopup.css("display", "block");
    suggestionsElementembarque_popup.css("display", "none");
  });

  inputElementembarque_popup.on("input", function () {
    if ($(this).val().trim() !== "") {
      suggestionsElementembarque_popup.empty();
    }
  });

  $(document).on("click", function (e) {
    if (
      suggestionsElementembarque_popup.css("display") === "block" &&
      !$(e.target).closest(suggestionsElementembarque_popup).length &&
      !$(e.target).is(inputElementembarque_popup) &&
      !$(e.target).hasClass("suggestions-embarque")
    ) {
      const selectedValue = suggestionsElementembarque_popup
        .find("li.active")
        .data("value");
      if (!selectedValue) {
        inputElementembarque_popup.val("");
        suggestionsElementembarque_popup.empty();
      }
    }
  });

  // Auto Suggest - Desembarque

  const inputElementdesembarque_sidebar = $(
    "#passagem-frame-vdp .desembarque-passagem"
  );
  const suggestionsElementdesembarque_sidebar = $(
    "#passagem-frame-vdp .suggestions-desembarque"
  );
  const noResultsMessagedesembarque_sidebar = "Nenhum local encontrado.";

  inputElementdesembarque_sidebar.on("input", function () {
    const term = $(this).val();
    reverseSidebar.css("display", "none");
    suggestionsElementdesembarque_sidebar.css("display", "block");

    $.ajax({
      url: `https://geo.vaidepromo.com.br/autosuggest?term=${term}`,
      method: "GET",
      success: function (data) {
        suggestionsElementdesembarque_sidebar.empty();

        if (data.result.length === 0) {
          const noResultsItem_sidebar = `<li class="no-results">${noResultsMessagedesembarque_sidebar}</li>`;
          suggestionsElementdesembarque_sidebar.append(noResultsItem_sidebar);
        } else {
          data.result.forEach(function (item) {
            const airportCode_sidebar = item[0];
            const airportName_sidebar = item[1];
            const suggestionItem_sidebar = `<li data-value="${airportName_sidebar}">${airportName_sidebar}</li>`;
            suggestionsElementdesembarque_sidebar.append(
              suggestionItem_sidebar
            );
          });
        }
      },
      error: function (error) {
        console.error("Erro na solicitação AJAX: " + error);
      },
    });
  });

  suggestionsElementdesembarque_sidebar.on("click", "li", function () {
    const selectedValue = $(this).data("value");
    inputElementdesembarque_sidebar.val(selectedValue);
    suggestionsElementdesembarque_sidebar.empty();
    reverseSidebar.css("display", "block");
    suggestionsElementdesembarque_sidebar.css("display", "none");
  });

  inputElementdesembarque_sidebar.on("input", function () {
    if ($(this).val().trim() !== "") {
      suggestionsElementdesembarque_sidebar.empty();
    }
  });

  $(document).on("click", function (e) {
    if (
      suggestionsElementdesembarque_sidebar.css("display") === "block" &&
      !$(e.target).closest(suggestionsElementdesembarque_sidebar).length &&
      !$(e.target).is(inputElementdesembarque_sidebar) &&
      !$(e.target).hasClass("suggestions-embarque")
    ) {
      const selectedValue = suggestionsElementdesembarque_sidebar
        .find("li.active")
        .data("value");
      if (!selectedValue) {
        inputElementdesembarque_sidebar.val("");
        suggestionsElementdesembarque_sidebar.empty();
      }
    }
  });

  //

  const inputElementdesembarque_popup = $(
    "#passagem-frame-vdp-popup .desembarque-passagem"
  );
  const suggestionsElementdesembarque_popup = $(
    "#passagem-frame-vdp-popup .suggestions-desembarque"
  );
  const noResultsMessagedesembarque_popup = "Nenhum local encontrado.";

  inputElementdesembarque_popup.on("input", function () {
    const term = $(this).val();
    reversePopup.css("display", "none");
    suggestionsElementdesembarque_popup.css("display", "block");

    $.ajax({
      url: `https://geo.vaidepromo.com.br/autosuggest?term=${term}`,
      method: "GET",
      success: function (data) {
        suggestionsElementdesembarque_popup.empty();

        if (data.result.length === 0) {
          const noResultsItem_popup = `<li class="no-results">${noResultsMessagedesembarque_popup}</li>`;
          suggestionsElementdesembarque_popup.append(noResultsItem_popup);
        } else {
          data.result.forEach(function (item) {
            const airportCode_popup = item[0];
            const airportName_popup = item[1];
            const suggestionItem_popup = `<li data-value="${airportName_popup}">${airportName_popup}</li>`;
            suggestionsElementdesembarque_popup.append(suggestionItem_popup);
          });
        }
      },
      error: function (error) {
        console.error("Erro na solicitação AJAX: " + error);
      },
    });
  });

  suggestionsElementdesembarque_popup.on("click", "li", function () {
    const selectedValue = $(this).data("value");
    inputElementdesembarque_popup.val(selectedValue);
    suggestionsElementdesembarque_popup.empty();
    reversePopup.css("display", "block");
    suggestionsElementdesembarque_popup.css("display", "none");
    $(".localvdp").css("border-radius", "16px");
  });

  inputElementdesembarque_popup.on("input", function () {
    if ($(this).val().trim() !== "") {
      suggestionsElementdesembarque_popup.empty();
    }
  });

  $(document).on("click", function (e) {
    if (
      suggestionsElementdesembarque_popup.css("display") === "block" &&
      !$(e.target).closest(suggestionsElementdesembarque_popup).length &&
      !$(e.target).is(inputElementdesembarque_popup) &&
      !$(e.target).hasClass("suggestions-embarque")
    ) {
      const selectedValue = suggestionsElementdesembarque_popup
        .find("li.active")
        .data("value");
      if (!selectedValue) {
        inputElementdesembarque_popup.val("");
        suggestionsElementdesembarque_popup.empty();
      }
    }
  });

  $(document).on("click", function (e) {
    // Verifica se o clique não foi dentro dos elementos suggestions
    if (
      !$(e.target).closest(".suggestions-embarque").length &&
      !$(e.target).closest(".suggestions-desembarque").length
    ) {
      // Fecha os elementos suggestions
      reversePopup.css("display", "block");
      reverseSidebar.css("display", "block");
      $(".suggestions-embarque, .suggestions-desembarque").css(
        "display",
        "none"
      );
    }
  });

  //-----------------------------------------------------------------------------------------------------

  // Troca de reposta

  //Sidebar

  const reverseButton_sidebar = $(".sidebar-reverse-destino button");

  // Adiciona um evento de clique ao botão
  reverseButton_sidebar.on("click", function () {
    // Obtém os valores atuais dos campos de entrada
    const embarqueValue_sidebar = $("#embarque-passagem-sidebar").val();
    const desembarqueValue_sidebar = $("#desembarque-passagem-sidebar").val();

    // Troca os valores entre os campos de entrada
    $("#embarque-passagem-sidebar").val(desembarqueValue_sidebar);
    $("#desembarque-passagem-sidebar").val(embarqueValue_sidebar);
  });

  // Popup

  const reverseButton_popup = $(".popup-reverse-destino button");

  // Adiciona um evento de clique ao botão
  reverseButton_popup.on("click", function () {
    // Obtém os valores atuais dos campos de entrada
    const embarqueValue_popup = $("#embarque-passagem-popup").val();
    const desembarqueValue_popup = $("#desembarque-passagem-popup").val();

    // Troca os valores entre os campos de entrada
    $("#embarque-passagem-popup").val(desembarqueValue_popup);
    $("#desembarque-passagem-popup").val(embarqueValue_popup);
  });

  //-----------------------------------------------------------------------------------------------------

  // Ida e volta

  $("#passagem-frame-vdp .so-ida").click(function () {
    $("#passagem-frame-vdp .volta").css("opacity", "0.4");
    $("#passagem-frame-vdp .volta input").prop("disabled", true);
    $("#passagem-frame-vdp .so-ida").addClass("active-opt");
    $("#passagem-frame-vdp .ida-volta").removeClass("active-opt");
  });

  $("#passagem-frame-vdp .ida-volta").click(function () {
    $("#passagem-frame-vdp .volta").css("opacity", "1");
    $("#passagem-frame-vdp .volta input").prop("disabled", false);
    $("#passagem-frame-vdp .ida-volta").addClass("active-opt");
    $("#passagem-frame-vdp .so-ida").removeClass("active-opt");
  });

  $("#passagem-frame-vdp-popup .so-ida").click(function () {
    $("#passagem-frame-vdp-popup .volta").css("opacity", "0.4");
    $("#passagem-frame-vdp-popup .volta input").prop("disabled", true);
    $("#passagem-frame-vdp-popup .so-ida").addClass("active-opt");
    $("#passagem-frame-vdp-popup .ida-volta").removeClass("active-opt");
  });

  $("#passagem-frame-vdp-popup .ida-volta").click(function () {
    $("#passagem-frame-vdp-popup .volta").css("opacity", "1");
    $("#passagem-frame-vdp-popup .volta input").prop("disabled", false);
    $("#passagem-frame-vdp-popup .ida-volta").addClass("active-opt");
    $("#passagem-frame-vdp-popup .so-ida").removeClass("active-opt");
  });

  //-----------------------------------------------------------------------------------------------------

  // Quantidade de passageiros

  $("#quantidade-passagem-popup").click(function () {
    $("#closeOption-popup").css("display", "block");
  });

  $("#quantidade-passagem-sidebar").click(function () {
    $("#closeOption").css("display", "block");
  });

  //-----------------------------------------------------------------------------------------------------

  // Datepicker

  var dataAtual = new Date();
  var dataMinima = new Date(
    dataAtual.getFullYear(),
    dataAtual.getMonth(),
    dataAtual.getDate() + 1
  );

  var dataFormatada = $.datepicker.formatDate("dd/mm/yy", dataMinima);

  $("#from-passagem-popup-datepicker").datepicker({
    numberOfMonths: 1,
    dateFormat: "dd/mm/yy",
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
    ],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S", "D"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    minDate: dataFormatada,
    onSelect: function (dateText, inst) {
      // Atualiza o valor do input com a data selecionada
      $("#from-passagem-popup").val(dateText);
      $(this).css("display", "none");
      $("#to-passagem-popup-datepicker").datepicker(
        "option",
        "minDate",
        dateText
      );
    },
  });

  $("#to-passagem-popup-datepicker").datepicker({
    numberOfMonths: 1,
    dateFormat: "dd/mm/yy",
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
    ],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S", "D"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    minDate: dataFormatada,
    onSelect: function (dateText, inst) {
      // Atualiza o valor do input com a data selecionada
      $("#to-passagem-popup").val(dateText);
      $(this).css("display", "none");
    },
  });

  //

  $("#from-passagem-sidebar-datepicker").datepicker({
    numberOfMonths: 1,
    dateFormat: "dd/mm/yy",
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
    ],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S", "D"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    minDate: dataFormatada,
    onSelect: function (dateText, inst) {
      // Atualiza o valor do input com a data selecionada
      $("#from-passagem-sidebar").val(dateText);
      $(this).css("display", "none");
      $("#to-passagem-sidebar-datepicker").datepicker(
        "option",
        "minDate",
        dateText
      );
    },
  });

  $("#to-passagem-sidebar-datepicker").datepicker({
    numberOfMonths: 1,
    dateFormat: "dd/mm/yy",
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
    ],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S", "D"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    minDate: dataFormatada,
    onSelect: function (dateText, inst) {
      // Atualiza o valor do input com a data selecionada
      $("#to-passagem-sidebar").val(dateText);
      $(this).css("display", "none");
    },
  });

  $("#from-passagem-sidebar-datepicker").hide();

  $("#from-passagem-sidebar").on("click", function (e) {
    e.stopPropagation(); // Impede que o clique se propague para o documento
    $("#from-passagem-sidebar-datepicker").show();
  });

  // Impede que o foco nos botões de navegação do calendário se propague para o elemento #from-passagem-sidebar-datepicker
  $(".ui-datepicker-prev, .ui-datepicker-next").on("mousedown", function (e) {
    e.stopPropagation();
  });

  $(document).on("mousedown", function (e) {
    if (
      !$("#from-passagem-sidebar-datepicker").is(e.target) &&
      !$("#from-passagem-sidebar-datepicker").has(e.target).length
    ) {
      // Verifica se o clique não ocorreu dentro do #from-passagem-sidebar-datepicker
      $("#from-passagem-sidebar-datepicker").hide();
    }
  });

  //

  $("#to-passagem-sidebar-datepicker").hide();

  $("#to-passagem-sidebar").on("click", function (e) {
    e.stopPropagation(); // Impede que o clique se propague para o documento
    $("#to-passagem-sidebar-datepicker").show();
  });

  $(document).on("mousedown", function (e) {
    if (
      !$("#to-passagem-sidebar-datepicker").is(e.target) &&
      !$("#to-passagem-sidebar-datepicker").has(e.target).length
    ) {
      // Verifica se o clique não ocorreu dentro do #to-passagem-sidebar-datepicker
      $("#to-passagem-sidebar-datepicker").hide();
    }
  });

  //

  $("#from-passagem-popup-datepicker").hide();

  $("#from-passagem-popup").on("click", function (e) {
    e.stopPropagation(); // Impede que o clique se propague para o documento
    $("#from-passagem-popup-datepicker").show();
  });

  $(document).on("mousedown", function (e) {
    if (
      !$("#from-passagem-popup-datepicker").is(e.target) &&
      !$("#from-passagem-popup-datepicker").has(e.target).length
    ) {
      // Verifica se o clique não ocorreu dentro do #from-passagem-popup-datepicker
      $("#from-passagem-popup-datepicker").hide();
    }
  });

  //

  $("#to-passagem-popup-datepicker").hide();

  $("#to-passagem-popup").on("click", function (e) {
    e.stopPropagation(); // Impede que o clique se propague para o documento
    $("#to-passagem-popup-datepicker").show();
  });

  $(document).on("mousedown", function (e) {
    if (
      !$("#to-passagem-popup-datepicker").is(e.target) &&
      !$("#to-passagem-popup-datepicker").has(e.target).length
    ) {
      // Verifica se o clique não ocorreu dentro do #to-passagem-popup-datepicker
      $("#to-passagem-popup-datepicker").hide();
    }
  });

  //-----------------------------------------------------------------------------------------------------

  // Number input - Sidebar

  function atualizarCampoQuantidadePassagem_sidebar() {
    const adultos_sidebar = parseInt($("#adultosnumeros-sidebar").text());
    const menores_sidebar = parseInt($("#menoresnumero-sidebar").text());

    const totalPassageiros_sidebar = adultos_sidebar + menores_sidebar;
    const classeSelecionada_sidebar = $(
      "#opt-quantidade-passagem-box3-sidebar input[name='opcao']:checked"
    )
      .next()
      .text();

    const totalExibido_sidebar = Math.min(totalPassageiros_sidebar, 8);

    const textoExibido_sidebar = `${totalExibido_sidebar} passageiro(s), ${classeSelecionada_sidebar}`;
    $("#quantidade-passagem-sidebar").val(textoExibido_sidebar);
  }

  $(".incrementButton-sidebar").click(function () {
    const index_sidebar = $(".incrementButton-sidebar").index(this);
    const numeroAtual_sidebar = parseInt(
      $(".numero-sidebar").eq(index_sidebar).text()
    );

    if (getTotal_sidebar() + 1 <= 8) {
      $(".numero-sidebar")
        .eq(index_sidebar)
        .text(numeroAtual_sidebar + 1);
      atualizarCampoQuantidadePassagem_sidebar();

      if (index_sidebar === 1) {
        // Verifica se o botão clicado é de Menores
        adicionarSelectMenores(numeroAtual_sidebar + 1);
      }
    }
  });

  $(".decrementButton-sidebar").click(function () {
    const index_sidebar = $(".decrementButton-sidebar").index(this);
    const numeroAtual_sidebar = parseInt(
      $(".numero-sidebar").eq(index_sidebar).text()
    );

    if (numeroAtual_sidebar > 0) {
      if (getTotal_sidebar() - 1 >= 0) {
        $(".numero-sidebar")
          .eq(index_sidebar)
          .text(numeroAtual_sidebar - 1);
        atualizarCampoQuantidadePassagem_sidebar();

        if (index_sidebar === 1) {
          // Verifica se o botão clicado é de Menores
          adicionarSelectMenores(numeroAtual_sidebar - 1);
        }
      }
    }
  });

  $("#opt-quantidade-passagem-box3-sidebar input[name='opcao']").change(
    function () {
      $("#opt-quantidade-passagem-box3-sidebar input[name='opcao']")
        .not(this)
        .prop("checked", false);
      atualizarCampoQuantidadePassagem_sidebar();
    }
  );

  function adicionarSelectMenores(numero) {
    $("#idadeSelectContainer").empty(); // Limpa qualquer conteúdo anterior

    for (let i = 0; i < numero; i++) {
      const selectHtml = `
        <div class="row-menor-idade">
            <div>
              <img src="https://cdn.vaidepromo.com.br/blog/2024/06/menor.svg">
              <div>
              <p class="title-menor-idade">Idade do menor</p>
              <p class="subtitle-menor-idade">Ao finalizar a viagem</p>
              </div>
            </div>
            <div>
            <select name="idade-menor-${i + 1}">
              <option class="bebesidebar" value="bebe">0 a 23 meses</option>
              <option class="criancasidebar" value="criancas">2 a 12 anos</option>
              <option class="jovemAdutosidebar" value="jovemAdulto">13 a 17 anos</option>
            </select>
            </div>
        </div>
      `;
      $("#idadeSelectContainer").append(selectHtml);
    }
  }

  // Chamada inicial para garantir que os selects estejam corretos ao carregar a página
  $(document).ready(function () {
    adicionarSelectMenores(parseInt($("#menoresnumero-sidebar").text()));
    atualizarCampoQuantidadePassagem_sidebar();
  });

  function getTotal_sidebar() {
    let total_sidebar = 0;
    $(".numero-sidebar").each(function () {
      total_sidebar += parseInt($(this).text());
    });
    return total_sidebar;
  }

  // Number input - Popup

  function atualizarCampoQuantidadePassagem_popup() {
    const adultos_popup = parseInt($("#adultosnumeros-popup").text());
    const menores_popup = parseInt($("#menoresnumero-popup").text());

    const totalPassageiros_popup = adultos_popup + menores_popup;
    const classeSelecionada_popup = $(
      "#opt-quantidade-passagem-box3-popup input[name='opcao']:checked"
    )
      .next()
      .text();

    const totalExibido_popup = Math.min(totalPassageiros_popup, 8);

    const textoExibido_popup = `${totalExibido_popup} passageiro(s), ${classeSelecionada_popup}`;
    $("#quantidade-passagem-popup").val(textoExibido_popup);
  }

  $(".incrementButton-popup").click(function () {
    const index_popup = $(".incrementButton-popup").index(this);
    const numeroAtual_popup = parseInt(
      $(".numero-popup").eq(index_popup).text()
    );

    if (getTotal_popup() + 1 <= 8) {
      $(".numero-popup")
        .eq(index_popup)
        .text(numeroAtual_popup + 1);
      atualizarCampoQuantidadePassagem_popup();

      if (index_popup === 1) {
        // Verifica se o botão clicado é de Menores
        adicionarSelectMenoresPopup(numeroAtual_popup + 1);
      }
    }
  });

  $(".decrementButton-popup").click(function () {
    const index_popup = $(".decrementButton-popup").index(this);
    const numeroAtual_popup = parseInt(
      $(".numero-popup").eq(index_popup).text()
    );

    if (numeroAtual_popup > 0) {
      if (getTotal_popup() - 1 >= 0) {
        $(".numero-popup")
          .eq(index_popup)
          .text(numeroAtual_popup - 1);
        atualizarCampoQuantidadePassagem_popup();

        if (index_popup === 1) {
          // Verifica se o botão clicado é de Menores
          adicionarSelectMenoresPopup(numeroAtual_popup - 1);
        }
      }
    }
  });

  $("#opt-quantidade-passagem-box3-popup input[name='opcao']").change(
    function () {
      $("#opt-quantidade-passagem-box3-popup input[name='opcao']")
        .not(this)
        .prop("checked", false);
      atualizarCampoQuantidadePassagem_popup();
    }
  );

  function adicionarSelectMenoresPopup(numero) {
    $("#idadeSelectContainerPopup").empty(); // Limpa qualquer conteúdo anterior

    for (let i = 0; i < numero; i++) {
      const selectHtml = `
        <div class="row-menor-idade">
            <div>
              <img src="https://cdn.vaidepromo.com.br/blog/2024/06/menor.svg">
              <div>
              <p class="title-menor-idade">Idade do menor</p>
              <p class="subtitle-menor-idade">Ao finalizar a viagem</p>
              </div>
            </div>
            <div>
            <select name="idade-menor-${i + 1}">
              <option class="bebepopup" value="bebepopup">0 a 23 meses</option>
              <option class="criancapopup" value="criancaspopup">2 a 12 anos</option>
              <option class="jovemAdultopopup" value="jovemAdultopopup">13 a 17 anos</option>
            </select>
            </div>
        </div>
      `;
      $("#idadeSelectContainerPopup").append(selectHtml);
    }
  }

  // Chamada inicial para garantir que os selects estejam corretos ao carregar a página
  $(document).ready(function () {
    adicionarSelectMenoresPopup(parseInt($("#menoresnumero-popup").text()));
    atualizarCampoQuantidadePassagem_popup();
  });

  function getTotal_popup() {
    let total_popup = 0;
    $(".numero-popup").each(function () {
      total_popup += parseInt($(this).text());
    });
    return total_popup;
  }

  //-----------------------------------------------------------------------------------------------------

  // Checkbox

  const checkboxes1_sidebar = $(
    '#opt-quantidade-passagem-box3-sidebar input[type="checkbox"]'
  );
  checkboxes1_sidebar.on("change", function () {
    checkboxes1_sidebar.not(this).prop("checked", false);
  });

  const checkboxes2_sidebar = $('#opt-tipo-sidebar input[type="checkbox"]');
  checkboxes2_sidebar.on("change", function () {
    checkboxes2_sidebar.not(this).prop("checked", false);
  });

  const checkboxes1_popup = $(
    '#opt-quantidade-passagem-box3-popup input[type="checkbox"]'
  );
  checkboxes1_popup.on("change", function () {
    checkboxes1_popup.not(this).prop("checked", false);
  });

  const checkboxes2_popup = $('#opt-tipo-popup input[type="checkbox"]');
  checkboxes2_popup.on("change", function () {
    checkboxes2_popup.not(this).prop("checked", false);
  });

  //-----------------------------------------------------------------------------------------------------

  // Envio Form Seguros

  $("#passagem-frame-vdp").on("submit", function (e) {
    e.preventDefault();

    var embarque = $("#embarque-passagem-sidebar").val();
    var desembarque = $("#desembarque-passagem-sidebar").val();
    var from = $("#from-passagem-sidebar").val();
    var to = $("#to-passagem-sidebar").val();
    var adultos = parseInt($("#adultosnumeros-sidebar").text());
    var jovemAdulto = $(".jovemAdutosidebar:checked").length;
    var classe = $(
      "#opt-quantidade-passagem-box3-sidebar input[name='opcao']:checked"
    ).val();

    // Ajuste para contar jovens adultos como adultos
    adultos += jovemAdulto;

    var totalCriancas = 0;
    var totalBebes = 0;
    var totalJovensAdultos = 0;

    // Loop para verificar cada select de idade dos menores
    $("#idadeSelectContainer select").each(function () {
      var valorSelecionado = $(this).val();
      switch (valorSelecionado) {
        case "bebe":
          totalBebes++;
          break;
        case "criancas":
          totalCriancas++;
          break;
        case "jovemAdulto":
          totalJovensAdultos++;
          break;
        default:
          // Caso padrão, não fazer nada
          break;
      }
    });

    if (embarque === desembarque) {
      $("#localvdp1").css("border", "1px solid red");
      $("#localvdp2").css("border", "1px solid red");
      return;
    } else {
      var fromParts = from.split("/");
      var fromYear = fromParts[2].slice(-2);
      var fromDate = fromYear + fromParts[1] + fromParts[0];

      var isSoIda = $("#passagem-frame-vdp .so-ida").hasClass("active-opt");

      var toDate = "";
      if (!isSoIda) {
        var toParts = to.split("/");
        var toYear = toParts[2].slice(-2);
        toDate = toYear + toParts[1] + toParts[0];
      }

      var siglaEmbarque = getSiglaFromAPIResponse(embarque);
      var siglaDesembarque = getSiglaFromAPIResponse(desembarque);

      var url = "https://www.vaidepromo.com.br/passagens-aereas/pesquisa/";

      if (isSoIda) {
        url += siglaEmbarque + siglaDesembarque + fromDate;
      } else {
        url +=
          siglaEmbarque +
          siglaDesembarque +
          fromDate +
          "-" +
          siglaDesembarque +
          siglaEmbarque +
          toDate;
      }

      url +=
        "/" + adultos + "/" + totalCriancas + "/" + totalBebes + "/" + classe;

      window.open(url, "_blank");
    }
  });

  $("#passagem-frame-vdp-popup").on("submit", function (e) {
    e.preventDefault();

    var embarque = $("#embarque-passagem-popup").val();
    var desembarque = $("#desembarque-passagem-popup").val();
    var from = $("#from-passagem-popup").val();
    var to = $("#to-passagem-popup").val();
    var adultos = parseInt($("#adultosnumeros-popup").text());
    var jovemAdulto = 0;
    var classe = $(
      "#opt-quantidade-passagem-box3-popup input[name='opcao']:checked"
    ).val();

    // Loop para verificar cada select de idade dos menores e contar os jovens adultos
    $("#idadeSelectContainerPopup select").each(function () {
      var valorSelecionado = $(this).val();
      if (valorSelecionado === "jovemAdultopopup") {
        jovemAdulto++;
      }
    });

    // Ajuste para contar jovens adultos como adultos
    adultos += jovemAdulto;

    var totalCriancas = 0;
    var totalBebes = 0;

    // Loop para verificar cada select de idade dos menores e contar bebês e crianças
    $("#idadeSelectContainerPopup select").each(function () {
      var valorSelecionado = $(this).val();
      switch (valorSelecionado) {
        case "bebepopup":
          totalBebes++;
          break;
        case "criancaspopup":
          totalCriancas++;
          break;
        default:
          // Caso padrão, não fazer nada
          break;
      }
    });

    if (embarque === desembarque) {
      $("#localvdp3").css("border", "1px solid red");
      $("#localvdp4").css("border", "1px solid red");
      return;
    } else {
      var fromParts = from.split("/");
      var fromYear = fromParts[2].slice(-2);
      var fromDate = fromYear + fromParts[1] + fromParts[0];

      var isSoIda = $("#passagem-frame-vdp-popup .so-ida").hasClass(
        "active-opt"
      );

      var toDate = "";
      if (!isSoIda) {
        var toParts = to.split("/");
        var toYear = toParts[2].slice(-2);
        toDate = toYear + toParts[1] + toParts[0];
      }

      var siglaEmbarque = getSiglaFromAPIResponse(embarque);
      var siglaDesembarque = getSiglaFromAPIResponse(desembarque);

      var url = "https://www.vaidepromo.com.br/passagens-aereas/pesquisa/";

      if (isSoIda) {
        url += siglaEmbarque + siglaDesembarque + fromDate;
      } else {
        url +=
          siglaEmbarque +
          siglaDesembarque +
          fromDate +
          "-" +
          siglaDesembarque +
          siglaEmbarque +
          toDate;
      }

      url +=
        "/" + adultos + "/" + totalCriancas + "/" + totalBebes + "/" + classe;

      window.open(url, "_blank");
    }
  });

  // Manipula a ativação/desativação do campo to-passagem

  $("#passagem-frame-vdp .so-ida").on("change", function () {
    var isChecked = $(this).is(":checked");
    $("#passagem-frame-vdp .to-passagem").prop("disabled", isChecked);

    if (isChecked) {
      $("#passagem-frame-vdp .to-passagem").val("");
    }
  });

  $("#passagem-frame-vdp-popup .so-ida").on("change", function () {
    var isChecked = $(this).is(":checked");
    $("#passagem-frame-vdp-popup .to-passagem").prop("disabled", isChecked);
  });

  // Função para obter a sigla do local a partir da resposta da API
  function getSiglaFromAPIResponse(local) {
    var matches = local.match(/\((.*?)\)/);
    if (matches && matches.length > 1) {
      return matches[1];
    }
    return "";
  }

  // Anime

  const titulo = document.getElementById("text-digit");
  const imagem_digit = document.getElementById("image-digit");

  typing(titulo).then(() => {
    setTimeout(() => {
      erasing().then(() => {
        titulo.style.display = "none";
      });
    }, 5000);
  });

  function typing(elemento) {
    return new Promise((resolve) => {
      const textArray = elemento.innerHTML.split("");
      elemento.innerHTML = "";
      textArray.forEach((letra, i) => {
        setTimeout(() => {
          elemento.innerHTML += letra;
          if (i === textArray.length - 1) {
            resolve();
          }
        }, 70 * i);
      });
    });
  }

  function erasing() {
    return new Promise((resolve) => {
      const textArray = titulo.innerHTML.split("");
      let i = textArray.length - 1;
      let timer = setInterval(() => {
        if (textArray.length > 0) {
          textArray.splice(i, 1);
          titulo.innerHTML = textArray.join("");
          i--;
        } else {
          clearInterval(timer);
          resolve();
        }
      }, 50);
    });
  }
});

//

const inputEmbarque = document.getElementById("embarque-passagem-sidebar");
const labelEmbarque = document.getElementById("label-embarque");
const inputDesembarque = document.getElementById(
  "desembarque-passagem-sidebar"
);
const labelDesembarque = document.getElementById("label-desembarque");
const inputEmbarquePopup = document.getElementById("embarque-passagem-popup");
const inputDesembarquePopup = document.getElementById(
  "desembarque-passagem-popup"
);
const labelEmbarquePopup = document.getElementById("label-embarque-popup");
const labelDesembarquePopup = document.getElementById(
  "label-desembarque-popup"
);

function handleInputFocus(input, label) {
  input.removeAttribute("placeholder");

  label.style.height = "auto";
  label.style.fontSize = "11px";
  label.style.display = "block";
  label.style.opacity = "1";
  input.style.transition = "font-size 0.3s";
  input.style.fontSize = "13px";
}

function handleInputBlur(input, label, placeholderOriginal) {
  if (input.value.trim() === "") {
    input.setAttribute("placeholder", placeholderOriginal);
    label.style.height = "0";
    label.style.fontSize = "0";
    label.style.display = "none";
    label.style.opacity = "0";
    input.style.transition = "font-size 0.3s";
    input.style.fontSize = "15px";
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/frame.js